<template>
  <div class>
    <!--=== Header Start ===-->
    <header class="header-navbar sticky-top">
      <div class="container-fluid p-0">
        <div class="row">
          <div class="col-md-12 px-0 py-0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="left-logo edu-banner">
                <a href>
                  <img id="imgBanner" v-bind:src="BannerURL" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div
      class="
        page-effect
        RegEvent-wrapper
        edu-rage
        event_list_reg
        ss-pre-ev-list
      "
      v-if="!verificationExpiry"
    >
      <section class="event-box-list-wrapper">
        <div class="container-fluid"></div>
      </section>
      <div class="success-verify-box">
        <img src="../assets/Images/reg-ico/success.svg" />
        <p>Email verified successfully.</p>
        <p class="mt-0">Redircting to login...</p>
        <h4>{{ countDown }}</h4>
      </div>
    </div>

    <div
      class="
        page-effect
        RegEvent-wrapper
        edu-rage
        event_list_reg
        ss-pre-ev-list
      "
      v-if="verificationExpiry"
    >
      <section class="event-box-list-wrapper">
        <div class="container-fluid"></div>
      </section>
      <div class="success-verify-box">
        <img src="../assets/Images/reg-ico/alert-outline.svg" />
        <p>The Link is no longer valid, please sign up again</p>

        <!-- <p class="mt-0">Redircting to login...</p> -->
        <!-- <h4>{{ countDown }}</h4> -->
      </div>
    </div>
  </div>
</template>
<script>
import db from "../components/firebaseInit";
import APIs from "@/components/APIInit";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
import firebase from "firebase";
import "firebase/auth";
import store from "../store";
import jwt_decode from "jwt-decode";

Vue.use(VueMoment, {
  moment,
});

export default {
  data() {
    return {
      noEventLink: "https://e2m.live/",
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      searchText: "",
      EnableEventFilter: false,
      EnableAddToCalender: false,
      advancedSearch: false,
      filterDateFrom: "",
      filterDateTo: "",
      filterRegion: "",
      filterType: "",
      RecentFilterTab: "today",
      startDate: "",
      endDate: "",
      regions: [],
      countDown: 10,
      tokenForUser: "",
      verificationSuccess: false,
      verificationExpiry: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    self = this;
    //self.showSnackbar("show");

    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
    this.countDownTimer();
    //this.showSnackbar("show");
  },
  mounted() {
    self.noEventLink = self.$t("client.registerRoute");
    self.clientID = self.$route.query.c;
    self.tokenForUser = self.$route.query.sst;

    if (self.tokenForUser != "") {
      self.registerUserForEventAdmin();
    }
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      //this.result = "uatonair.e2m.live";
      //self.hostName = "onair.e2m.live";
      self.hostName = HOSTURL ? HOSTURL : "uatonair.e2m.live";
      // self.hostName = "uatbni.e2m.live";
      // this.result = "tci.e2m.live";
      //this.result = "uatcapitalgroup.e2m.live";
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
      //self.hostName = location.host;
    }
    var path;
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        db.collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(self.clientID)
          .get()
          .then(function (doc) {
            var data = doc.data();
            console.log(data);
            //debugger;
            self.clientLogoUrl = data.LoginAssets.logo;
            self.ClientName = data.ClientName;
            self.clientProfile = data.Company;

            self.desktopBanner = data.EventListAssets.banner2048x88;
            self.mobileBanner = data.EventListAssets.banner750x103;
            //  self.BannerURL = data.EventListAssets.banner640x88;
            self.initScreen();
          });
      });

    //------------------------------------------------------------------------------------

    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

    $("#imgBanner").attr("src", self.BannerURL);
  },
  methods: {
    registerUserForEventAdmin() {
      var requestData = {};
      let headers = {
        "content-type": "application/json",
      };

      requestData = {
        token: self.tokenForUser,
      };
      axios
        .post(APIs.userEventAdminRegister, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          //self.showSnackbar("hide");
          console.log("data========", responseData.data);

          if (responseData.data.status == 0) {
            debugger;

            console.log("data========", responseData.data);
            var data = responseData.data.data;

            firebase
              .auth()
              .signInWithCustomToken(responseData.data.customToken)
              .then(function (res) {
                res.user
                  .getIdToken(true)
                  .then((idToken) => {
                    var decoded = jwt_decode(idToken);
                    console.log("after decode========", data);
                    console.log("after decode==2======", responseData.data);

                    // if (responseData.data.userEvents.length > 0) {
                    //   document.cookie =
                    //     "Set-Cookie:name=" +
                    //     data.userEvents.result[0].client.ClientName +
                    //     ";" +
                    //     "domain=e2m.live";
                    // }

                    document.cookie = "token=";
                    document.cookie = "token=" + idToken + ";";
                    self.$store.commit("addToken", idToken);
                    self.$store.commit("setCurrentLoggedInTime", decoded.exp);

                    document.cookie = "staysigned=";
                    document.cookie = "userrole=";
                    document.cookie = "userid=";

                    ////////// After token and cookies set send to event////////////////////
                    store.commit("setLoginType", "Login");

                    var eventCount = 0;
                    // if (data.userEvents.length > 0) {
                    //   eventCount = data.userEvents.result.reduce(
                    //     (total, user) => {
                    //       return total + user.events.length;
                    //     },
                    //     0
                    //   );
                    // }

                    store.commit("addEventCount", eventCount);

                    var userData = data;
                    var userRoles = userData.UserRoles;
                    var roles = [];
                    // var isClientAdmin = false;
                    // var isEventAdmin = false;

                    if (userRoles != undefined) {
                      userRoles.forEach(function (role) {
                        // if (role.RoleID == 2) {
                        //   isClientAdmin = true;
                        // } else if (role.RoleID == 3) {
                        //   isEventAdmin = true;
                        // }
                        roles.push(role.RoleID);
                      });
                    }

                    store.state.userRole = userRoles;

                    // var result = data.userEvents.result;
                    // var events = [];
                    // var i;
                    // var j;

                    // for (i = 0; i < result.length; ++i) {
                    //   for (j = 0; j < result[i].events.length; j++) {
                    //     if (!isClientAdmin && !isEventAdmin) {
                    //       if (result[i].events[j].IsPublished == true) {
                    //         events.push(result[i].events[j]);
                    //       }
                    //     } else {
                    //       events.push(result[i].events[j]);
                    //     }
                    //   }
                    // }

                    // store.commit("setMappedEvent", events);
                    // store.commit("addEventCount", events.length);

                    store.commit("addAttendeeID", userData.UserId);
                    var UserType = "Attendee";
                    if (userData.RegistrationTypes != undefined)
                      for (var reg in userData.RegistrationTypes) {
                        if (
                          userData.RegistrationTypes[reg].RegistrationType ==
                          "Speaker"
                        ) {
                          UserType = "Speaker";
                        }
                      }

                    store.commit("addUser", {
                      id: userData.UserId,
                      Email: userData.Email,
                      name: userData.Name,
                      fname: userData.FirstName,
                      lname: userData.LastName,
                      profilepic: userData.ProfilePictureURL,
                      company: userData.Company,
                      title: userData.Designation,
                      phone: userData.Phone,
                      roles: roles,
                      userType: UserType,
                    });
                    console.log(
                      `before push Success Execution time:`,
                      new Date()
                    );
                    console.log("before push>>>>>>>>>>");
                    //router.push({ name: "AdminOverview" });
                    router.push({ name: "BasicInfo" });
                  })
                  .catch((err) => {
                    console.log("err=====", err);
                  });
              })
              .catch(function (e) {
                console.log(e);
              });
          } else if (responseData.data.status == -10) {
            self.verificationExpiry = true;
          } else if (responseData.data.status == -11) {
            self.verificationExpiry = true;
          }
          else if (responseData.data.status == -35) {
            self.verificationExpiry = true;
            self.goForLogin();
          }
        })
        .catch((error) => {
          //self.showSnackbar("hide");
          console.log("Error:" + error);
        });
    },
    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
  },
};
</script>